import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Link, type LinkProps } from '@tanstack/react-router';
import { memo, useMemo, type ReactNode } from 'react';

type SideMenuItemProps = {
  to: LinkProps['to'];
  searchParams?: string;
  icon?: ReactNode;
  open: boolean;
  children: ReactNode;
  onClick?: () => void;
};

const SideMenuItem = ({ to, searchParams, icon, open, children, onClick }: SideMenuItemProps) => {
  // searchParams がある場合は上書き
  // searchParams がなく、ページへのリンクの場合は既存のパラメータを保持
  // それ以外の場合は undefined（クエリパラメータをクリア）
  const search = useMemo(() => {
    if (to === '/vehicles/') {
      return searchParams ? { project_ids: searchParams } : undefined;
    }
    if (to === '/transfer/') {
      return searchParams ? { project_id: searchParams } : undefined;
    }
  }, [searchParams, to]);

  return (
    <ListItem disablePadding sx={{ px: 1.8, minHeight: 48 }} onClick={onClick}>
      <Link
        to={to}
        search={search}
        style={{ width: '100%', textDecoration: 'none', color: 'inherit' }}
      >
        <ListItemButton>
          {icon && <ListItemIcon sx={{ color: '#fff', minWidth: 40 }}>{icon}</ListItemIcon>}
          {open && <ListItemText primary={children} sx={{ ml: 2 }} />}
        </ListItemButton>
      </Link>
    </ListItem>
  );
};

export default memo(SideMenuItem);
